var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70711 9.79289C7.09763 10.1834 7.09763 10.8166 6.70711 11.2071L1.70711 16.2071C1.31658 16.5976 0.683417 16.5976 0.292893 16.2071C-0.0976311 15.8166 -0.0976311 15.1834 0.292893 14.7929L5.29289 9.79289C5.68342 9.40237 6.31658 9.40237 6.70711 9.79289Z",
    fill: "url(#paint0_radial_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C7.51472 2 5.5 4.01472 5.5 6.5C5.5 8.98528 7.51472 11 10 11C12.4853 11 14.5 8.98528 14.5 6.5C14.5 4.01472 12.4853 2 10 2ZM3.5 6.5C3.5 2.91015 6.41015 0 10 0C13.5899 0 16.5 2.91015 16.5 6.5C16.5 10.0899 13.5899 13 10 13C6.41015 13 3.5 10.0899 3.5 6.5Z",
    fill: "url(#paint1_radial_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7 9.5) rotate(135) scale(9.89949 9.2615)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0626D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5) rotate(135) scale(18.3848 17.1999)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0626D7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.7577fe3c3aa75c6ad3d2e0a6b5230440.svg";
export { ForwardRef as ReactComponent };